import React, { memo } from 'react';
import DisplayPublicFooter from '../display-public-footer';

/**
 * 页面包裹
 * @param children
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
const Page = ({ children, ...rest }) => {
  return (
    <div {...rest}>
      {children}
      <DisplayPublicFooter />
    </div>
  );
};

export default memo(Page);
